import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Typography,
  Box,
} from "@mui/material";
import { useDispatch } from "react-redux";
import { recordPayment } from "../redux/slices/invoiceSlice";
import { toast } from "react-toastify";
import PostAddIcon from "@mui/icons-material/PostAdd";


const AddEntryModal = ({ invoiceId, seller, id, dueDate }) => {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    amount: "",
    description: "",
    date: "",
  });

  const [open, setOpen] = useState(false);

  const handleClose = () => setOpen(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const formatDateForInput = (date) => {
    if (!date) return "";

    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };

  const handleSubmit = async () => {
    if (!formData.amount || formData.amount <= 0) {
      toast.error("Please enter a valid amount");
      return;
    }

    // Date validation
    if (formData.date && dueDate) {
      const selectedDate = new Date(formData.date);
      const invoiceDueDate = new Date(dueDate);

      if (selectedDate < invoiceDueDate) {
        toast.error("Payment date cannot be before due date");
        return;
      }
    }

    const paymentData = {
      invoiceId,
      amount: Number(formData.amount),
      note: formData.description,
      paidAt: formData.date || undefined,
    };

    try {
      const resultAction = await dispatch(recordPayment(paymentData));

      if (recordPayment.fulfilled.match(resultAction)) {
        toast.success("Payment recorded successfully");
        handleClose();

        setFormData({
          amount: "",
          description: "",
          date: "",
        });
      } else {
        toast.error(
          resultAction.payload?.message ||
            resultAction.error?.message ||
            "Failed to record payment"
        );
      }
    } catch (error) {
      toast.error("Something went wrong");
    }
  };

  return (
    <>
      <Button
        variant="outlined"
        sx={{ borderRadius: 2 }}
        size="small"
        startIcon={<PostAddIcon />}
        onClick={() => setOpen(true)}
      >
        New Entry
      </Button>

       

      <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle>Add New Entry</DialogTitle>
        <DialogContent>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
            <Typography variant="caption" fontWeight={600}>
              Invoice Number: {id}
            </Typography>

            <TextField label="Seller Name" value={seller} disabled />

            <TextField
              label="Amount"
              name="amount"
              type="number"
              value={formData.amount}
              onChange={handleChange}
            />

            <TextField
              label="Description"
              name="description"
              multiline
              rows={3}
              value={formData.description}
              onChange={handleChange}
            />

            <TextField
              label="Date"
              name="date"
              type="date"
              InputLabelProps={{ shrink: true }}
              inputProps={{
                min: formatDateForInput(dueDate),
              }}
              value={formData.date}
              onChange={handleChange}
            />
          </Box>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleSubmit} variant="contained">
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default AddEntryModal;
